import { isEmpty } from "@/utils/query-string";
import { ClasePoliticaEnum } from "../../schema/request-policies.schema";
import { Card, Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import { AppColors } from "@/styles/colors";
import { CustomCheckboxGroup } from "@/components/checkbox/checkbox-group";
import { PolicyTimeAlert } from "@/components/common/section-components/alert/PolicyTimeAlert";
import { InputField } from "@/components/input-field/InputField";
import { Control, FieldValues } from "react-hook-form";
import { weekOrderSP } from "@/constants/week-days";

interface Props {
  clase?: ClasePoliticaEnum[];
  control: Control<FieldValues>;
  loading?: boolean;
}

export const PolicyTimeAndDayValueInputView = ({
  clase,
  control,
  loading,
}: Props) => {
  if (!isEmpty(clase) && clase?.[0] !== ClasePoliticaEnum.TopeDiario)
    return (
      <Card.Root
        maxW="full"
        marginTop="30px"
        borderRadius="8px"
        data-testid="policy-time-and-day-inputs"
      >
        <Card.Body
          paddingX="48px"
          paddingY="30px"
          borderRadius="8px"
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
        >
          {clase?.[0] === ClasePoliticaEnum.RangoSemanal && (
            <Flex flexDir="column" gap="30px">
              <Text fontWeight={600} fontSize={"20px"}>
                Días
              </Text>

              <CustomCheckboxGroup
                name="dias"
                control={control}
                items={weekOrderSP}
                gap="30px"
                disabled={loading}
              />
            </Flex>
          )}
          {clase?.[0] === ClasePoliticaEnum.Horario && (
            <Flex flexDir="column" gap="30px">
              <PolicyTimeAlert />
              <Grid templateColumns={"repeat(4, 1fr)"} spaceX={"16px"}>
                <GridItem paddingY="8px">
                  <InputField
                    labelText="Hora desde"
                    type="time"
                    control={control}
                    inputName="horaDesde"
                    required
                    minTime="00:00"
                    maxTime="23:59"
                    disabled={loading}
                  />
                </GridItem>
                <GridItem paddingY="8px">
                  <InputField
                    labelText="Hora hasta"
                    type="time"
                    control={control}
                    inputName="horaHasta"
                    required
                    minTime="00:00"
                    maxTime="23:59"
                    disabled={loading}
                  />
                </GridItem>
              </Grid>
            </Flex>
          )}
        </Card.Body>
      </Card.Root>
    );
};
